<template>
  <div class="action-item-wrapper">
    <lang-select @selectLang="selectedLang = $event"/>
    <div class="action-item" @click="$store.state.core.featuresStatus.text_to_speech = !$store.state.core.featuresStatus.text_to_speech " :class="{active: $store.state.core.featuresStatus.text_to_speech }">
      <div class="active-action item" v-if="$store.state.core.featuresStatus.text_to_speech ">
        <span class="icon-check"></span>
      </div>


      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div
              v-bind="attrs"
              v-on="on"
          >
            <div v-html="icons.textToSpeech"></div>
            <h3>{{$t('Read Page')}}</h3>
          </div>
        </template>
        <span>{{$t('Select text to hear it read aloud')}}</span>
      </v-tooltip>
    </div>
  </div>

</template>


<script>
    import langSelect from "@/components/langSelect";
    import {icons} from '../../utils/icons'
    export default {
        name: "text-to-speech",
      components: {
          langSelect
      },
        data() {
            return {
                active: false,
                icons,
                audioObject: new Audio(),
                text: '',
                selectedLang: null,
            }
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        mounted() {
            // document.addEventListener('click', e=> {
            //     if (this.active) {
            //         e = e || window.event;
            //         let target = e.target || e.srcElement
            //         let text = ''
            //         if (target.innerText) {
            //             text = target.innerText;
            //             if (text !== 'Read Page' && text !== 'read page') {
            //                 this.textToSpeech(text)
            //             }
            //         } else {
            //             if (e.childNodes || e.currentTarget.childNodes) {
            //                 let childs = e.childNodes || e.currentTarget.childNodes
            //                 for (let i = 0; i<childs.length; i++) {
            //                     this.getText(childs[i])
            //                 }
            //             }
            //         }
            //     }
            // }, false);
            document.addEventListener('selectionchange', () => {

                let ele = document.getSelection().toString()
                    if (this.$store.state.core.featuresStatus.text_to_speech  && typeof ele != 'object') {
                         this.text = ele
                    }
            });

            document.onmouseup = () => {
                if (this.$store.state.core.featuresStatus.text_to_speech  && this.text) {
                    this.textToSpeech(this.text)
                }
            }
        },
        methods: {
            textToSpeech(text){
                let audioFile = ''
                this.audioObject.pause()
                this.$http_ist.post('text-to-speech', {
                    payload: text,
                    lang: this.$store.state.core.featuresStatus.textToSpeechLang
                })
                    .then(response=>{
                        audioFile = response.data.data
                        this.audioObject.src = audioFile
                        this.audioObject.play()
                        this.text = ''
                    })
                    .catch(()=>{

                    })

            },
        },
        watch: {
            '$store.state.core.featuresStatus.text_to_speech': function (state) {
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
                if (!state) {
                    this.textToSpeech('')
                } else {
                    this.$emit('countAnalytics', this.data._id)
                }
            }
        }
    }
</script>

<style scoped>

</style>
